

// import { useState } from "react";

// function TermsCondition({ onClose }) {
//   const [checked, setChecked] = useState(false);

//   const handleSubmit = () => {
//     if (!checked) {
//       alert("Please accept Terms & Conditions");
//       return;
//     }
//     alert("Terms accepted");
//     onClose();
//   };

//   return (
//     <div className="terms-overlay">
//       <div className="terms-box">
//         <h4>Shopeindia – Terms & Conditions</h4>
//         <p className="terms-date">Effective Date: January 2026</p>

//         <div className="terms-content">
//           <p>
//             Welcome to <b>Shopeindia</b>. By accessing or using our website
//             <b> www.shopeindia.co.in</b>, you agree to comply with and be bound
//             by the following Terms & Conditions. If you do not agree, please
//             do not use our services.
//           </p>

//           <h5>1. Definitions</h5>
//           <p><b>Shopeindia</b> refers to our e-commerce platform operated from Warud, Maharashtra, India.</p>
//           <p><b>User / You</b> means any individual accessing or purchasing from the website.</p>
//           <p><b>Products</b> include medical, healthcare, wellness, beauty and related equipment.</p>

//           <h5>2. Eligibility</h5>
//           <p>You must be at least 18 years old to place an order.</p>
//           <p>You agree to provide accurate and complete information.</p>

//           <h5>3. Products & Services</h5>
//           <ul>
//             <li>Dermatology Equipments</li>
//             <li>Massage & Wellness Products</li>
//             <li>Hijama / Acupressure Tools</li>
//             <li>Aesthetic & Beauty Devices</li>
//             <li>Healthcare Tools & Devices</li>
//           </ul>

//           <h5>4. Orders & Payments</h5>
//           <p>
//             All orders are subject to availability and confirmation.
//             Prices may change without prior notice.
//           </p>
//           <p>
//             Payments must be completed through available payment methods.
//           </p>

//           <h5>5. Shipping & Delivery</h5>
//           <p>
//             Delivery timelines are estimates and may vary due to logistics,
//             location, or unforeseen circumstances.
//           </p>

//           <h5>6. Returns & Refunds</h5>
//           <p>
//             Returns and refunds are subject to our return policy.
//             Certain medical or hygiene products may not be returnable.
//           </p>

//           <h5>7. User Responsibilities</h5>
//           <ul>
//             <li>Use the website for lawful purposes only</li>
//             <li>Do not misuse content or product data</li>
//             <li>Do not attempt unauthorized access</li>
//           </ul>

//           <h5>8. Intellectual Property</h5>
//           <p>
//             All website content, logos, images, and text are the property
//             of Shopeindia and may not be used without permission.
//           </p>

//           <h5>9. Limitation of Liability</h5>
//           <p>
//             Shopeindia shall not be liable for indirect, incidental, or
//             consequential damages arising from website use.
//           </p>

//           <h5>10. Termination</h5>
//           <p>
//             We reserve the right to suspend or terminate access if terms
//             are violated.
//           </p>

//           <h5>11. Governing Law</h5>
//           <p>
//             These Terms shall be governed by the laws of India.
//           </p>

//           <h5>12. Contact Information</h5>
//           <p>
//             <b>Address:</b> Shopeindia, Warud, Maharashtra, India<br />
//             <b>Phone:</b> 7820953826 / 7385743121<br />
//             <b>Email:</b> shamun@shopeindia.co.in<br />
//             <b>Website:</b> www.shopeindia.co.in
//           </p>
//         </div>

//         <div className="terms-check">
//           <input
//             type="checkbox"
//             id="terms"
//             checked={checked}
//             onChange={(e) => setChecked(e.target.checked)}
//           />
//           <label htmlFor="terms">I agree to the Terms & Conditions</label>
//         </div>

//         <div className="terms-actions">
//           <button onClick={handleSubmit}>Accept</button>
//           <button className="cancel" onClick={onClose}>Close</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TermsCondition;



import { useState } from "react";
import { createPortal } from "react-dom";

function TermsCondition({ onClose }) {
  const [checked, setChecked] = useState(false);

  const handleSubmit = () => {
    if (!checked) {
      alert("Please accept Terms & Conditions to proceed.");
      return;
    }
    onClose();
  };

  return createPortal(
    <div className="terms-overlay" style={overlayStyle}>
      <div className="terms-box" style={boxStyle}>

        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "28px" }}>📋</span>
            <div>
              <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111" }}>
                Terms & Conditions
              </h4>
              <p style={{ margin: 0, fontSize: "12px", color: "#777" }}>
                Shopeindia — Effective Date: January 1, 2026
              </p>
            </div>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        {/* Scrollable Content */}
        <div style={contentStyle}>

          <p style={paraStyle}>
            Welcome to <b>Shopeindia</b> (<b>www.shopeindia.co.in</b>). By accessing or placing an order on our platform, you agree to be legally bound by the following Terms & Conditions. Please read them carefully before proceeding with any purchase.
          </p>

          <Section title="1. Company Information">
            <p style={paraStyle}><b>Business Name:</b> Shopeindia</p>
            <p style={paraStyle}><b>Address:</b> Shopeindia, Warud, Maharashtra, India</p>
            <p style={paraStyle}><b>Contact:</b>+91 7385743121</p>
            <p style={paraStyle}><b>Email:</b> support@shopeindia.co.in</p>
            <p style={paraStyle}><b>Website:</b> www.shopeindia.co.in</p>
          </Section>

          {/* <Section title="2. Eligibility">
            <p style={paraStyle}>You must be at least <b>18 years of age</b> to use this website or place any order. By using the site, you confirm that you meet this requirement and that all information provided is accurate and complete.</p>
          </Section> */}

          <Section title="2. Products We Sell">
            <p style={paraStyle}>Shopeindia specializes in wellness, medical, and healthcare equipment including but not limited to:</p>
            <ul style={listStyle}>
              <li>Hijama / Wet Cupping Therapy Tools & Kits</li>
              <li>Vacuum Cupping Sets (all sizes)</li>
              <li>Dermatology & Aesthetic Devices</li>
              <li>Massage & Wellness Products</li>
              <li>Acupressure & Acupuncture Tools</li>
              <li>Healthcare Tools & Medical Instruments</li>
              <li>E-Books and Online Courses (Digital Products)</li>
            </ul>
            <p style={paraStyle}>All products are for professional or personal wellness use. Shopeindia does not provide medical advice or treatment services.</p>
          </Section>

          <Section title="3. Orders & Pricing">
            <ul style={listStyle}>
              <li>All orders are subject to product availability and confirmation via email or SMS.</li>
              <li>Prices displayed are in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise.</li>
              <li>Shopeindia reserves the right to change prices at any time without prior notice.</li>
              <li>In case of pricing errors, we will contact you before processing your order.</li>
            </ul>
          </Section>

          <Section title="4. Payments">
            <ul style={listStyle}>
              <li>We accept payments via UPI, Debit/Credit Cards, Net Banking, and other available payment gateways.</li>
              <li>All transactions are secured via SSL encryption and processed through trusted payment partners.</li>
              <li>Shopeindia does not store your card or bank details.</li>
              <li>In case of payment failure, please retry or contact us. Double charges, if any, will be refunded within 5–7 working days.</li>
            </ul>
          </Section>

          <Section title="5. Shipping & Delivery">
            <ul style={listStyle}>
              <li>Orders are typically dispatched within <b>1–3 business days</b> of payment confirmation.</li>
              <li>Estimated delivery is <b>5–10 business days</b> depending on your location within India.</li>
              <li>Delivery timelines may vary due to location, courier delays, or unforeseen circumstances.</li>
              <li>Shopeindia is not liable for delays caused by courier partners or force majeure events.</li>
              <li>Shipping charges (if any) will be displayed at checkout.</li>
            </ul>
          </Section>

          <Section title="6. Cancellations">
            <ul style={listStyle}>
              <li>Orders can be cancelled <b>within 24 hours</b> of placement, provided they have not been dispatched.</li>
              <li>To cancel, contact us at <b>support@shopeindia.co.in</b> or call <b>+91 7385743121</b>.</li>
              <li>Once dispatched, cancellation is not possible. Please refer to our Return Policy.</li>
              <li>Digital products (e-books, courses) cannot be cancelled once purchased and accessed.</li>
            </ul>
          </Section>

          <Section title="7. User Responsibilities">
            <ul style={listStyle}>
              <li>Use the website and products only for lawful purposes.</li>
              <li>Do not attempt unauthorized access to any part of the platform.</li>
              <li>Do not misuse, reproduce, or resell products or content without written permission.</li>
              <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            </ul>
          </Section>

          <Section title="8. Intellectual Property">
            <p style={paraStyle}>All content on this website — including logos, images, product descriptions, course material, e-books, and text — is the exclusive property of Shopeindia. Unauthorized use, copying, or distribution is strictly prohibited.</p>
          </Section>

          <Section title="9. Limitation of Liability">
            <p style={paraStyle}>Shopeindia shall not be held liable for any indirect, incidental, special, or consequential damages arising from the use or inability to use our products or services. Our maximum liability in any case shall not exceed the amount paid by you for the specific order in question.</p>
          </Section>

          <Section title="10. Governing Law & Jurisdiction">
            <p style={paraStyle}>These Terms & Conditions are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in <b>Amravati, Maharashtra, India</b>.</p>
          </Section>

          <Section title="11. Changes to Terms">
            <p style={paraStyle}>Shopeindia reserves the right to update or modify these Terms at any time. Continued use of the website after any changes constitutes your acceptance of the revised terms.</p>
          </Section>

        </div>

        {/* Checkbox */}
        <div style={checkboxRowStyle}>
          <input
            type="checkbox"
            id="terms-check"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#24aeb1" }}
          />
          <label htmlFor="terms-check" style={{ fontSize: "14px", cursor: "pointer", color: "#333" }}>
            I have read and agree to the <b>Terms & Conditions</b> of Shopeindia.
          </label>
        </div>

        {/* Actions */}
        <div style={actionsStyle}>
          <button onClick={handleSubmit} style={acceptBtnStyle}>
            ✓ Accept & Continue
          </button>
          <button onClick={onClose} style={cancelBtnStyle}>
            Close
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
}

/* ─── Small helper ─── */
function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "18px" }}>
      <h5 style={{ fontSize: "14px", fontWeight: "700", color: "#24aeb1", marginBottom: "8px", borderBottom: "1px solid #e8f8f8", paddingBottom: "4px" }}>
        {title}
      </h5>
      {children}
    </div>
  );
}

/* ─── Styles ─── */
const overlayStyle = {
  position: "fixed", inset: 0,
  background: "rgba(0,0,0,0.65)",
  display: "flex", justifyContent: "center", alignItems: "center",
  zIndex: 99999,
  padding: "16px"
};

const boxStyle = {
  background: "#fff",
  width: "100%", maxWidth: "720px",
  borderRadius: "16px",
  display: "flex", flexDirection: "column",
  maxHeight: "90vh",
  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
  overflow: "hidden"
};

const headerStyle = {
  display: "flex", justifyContent: "space-between", alignItems: "center",
  padding: "18px 24px",
  borderBottom: "2px solid #e8f8f8",
  background: "#f7fffe",
  flexShrink: 0
};

const closeBtnStyle = {
  background: "#f1f5f9", border: "none",
  width: "32px", height: "32px", borderRadius: "50%",
  fontSize: "16px", cursor: "pointer", color: "#475569",
  display: "flex", alignItems: "center", justifyContent: "center"
};

const contentStyle = {
  overflowY: "auto", padding: "20px 24px",
  flex: 1, fontSize: "13.5px", color: "#444", lineHeight: "1.7"
};

const paraStyle = { marginBottom: "8px" };

const listStyle = {
  paddingLeft: "20px", marginBottom: "8px",
  display: "flex", flexDirection: "column", gap: "4px"
};

const checkboxRowStyle = {
  display: "flex", alignItems: "center", gap: "10px",
  padding: "14px 24px",
  borderTop: "1px solid #eee",
  background: "#fafffe",
  flexShrink: 0
};

const actionsStyle = {
  display: "flex", gap: "10px", justifyContent: "flex-end",
  padding: "14px 24px",
  borderTop: "1px solid #eee",
  flexShrink: 0
};

const acceptBtnStyle = {
  background: "#24aeb1", color: "#fff",
  border: "none", padding: "10px 24px",
  borderRadius: "8px", fontWeight: "600",
  fontSize: "14px", cursor: "pointer"
};

const cancelBtnStyle = {
  background: "#f1f5f9", color: "#333",
  border: "none", padding: "10px 20px",
  borderRadius: "8px", fontWeight: "500",
  fontSize: "14px", cursor: "pointer"
};

export default TermsCondition;